var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.icone)?_c('div',{class:[
    'botao-icone-container',
    { 'botao-icone-arredonda-esquerda': _vm.arredondadoEsquerda },
    { 'botao-icone-arredonda-direita': _vm.arredondadoDireita },
    _vm.cor ? ("icone-" + _vm.cor) : '',
    { desabilita: _vm.desabilita }
  ]},[(_vm.loading)?_c('div',{staticClass:"botao-icone"},[_c('LoadingPadraoContainerMini',{attrs:{"delay":"5000","classe":_vm.cor}})],1):_c('font-awesome-icon',{staticClass:"botao-icone",attrs:{"icon":_vm.icone}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }